import React, { createContext, useContext, useState, useEffect } from 'react';

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState('DOLLAR'); // Default to USD
  const [isCurrencyLoaded, setIsCurrencyLoaded] = useState(false);
  const [unit, setUnit] = useState('per100');

  useEffect(() => {
    const loadCurrency = () => {
      try {
        const savedCurrency = JSON.parse(localStorage.getItem("selectedCurrency"));
        if (savedCurrency?.code) {
          setCurrency(savedCurrency.code);
        } else {
          const savedCart = JSON.parse(localStorage.getItem("cartItems")) || [];
          if (savedCart.length > 0 && savedCart[0].currency?.code) {
            setCurrency(savedCart[0].currency.code);
          } else {
            setCurrency("DOLLAR");
          }
        }
      } finally {
        setIsCurrencyLoaded(true);
      }
    };

    const loadUnit = () => {
      const savedUnit = localStorage.getItem("priceDisplay");
      if (savedUnit) {
        setUnit(savedUnit);
      }
    };

    loadCurrency();
    loadUnit();
  }, []);

  useEffect(() => {
    // Save currency to localStorage whenever it changes
    if (isCurrencyLoaded) {
      const symbol = getCurrencySymbol(currency);
      localStorage.setItem("selectedCurrency", JSON.stringify({
        code: currency,
        symbol
      }));
    }
  }, [currency, isCurrencyLoaded]);

  const convertPrice = (price) => {
    if (!price) return 0;

    switch (currency) {
      case "RUPEE":
        return price * 100;
      case "EURO":
        return (price * 100) / 102.55;
      default: // USD
        return (price * 100) / 87.56;
    }
  };

  const convertThankyouPrice = (price, currency) => {
    if (!price) return 0;

    // Convert from USD to target currency
    switch (currency) {
      case "RUPEE":
        return price * 100;
      case "EURO":
        return price * 0.85;
      default: // USD
        return price;
    }
  };

  const getCurrencySymbol = (curr = currency) => {
    switch (curr) {
      case 'RUPEE':
        return '₹';
      case 'EURO':
        return '€';
      default: // USD
        return '$';
    }
  };

  const value = {
    currency,
    setCurrency,
    convertPrice,
    convertThankyouPrice,
    getCurrencySymbol,
    isCurrencyLoaded,
    unit,
    setUnit,
  };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (context === undefined) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
};